import { Link } from 'gatsby';
import tw, { styled } from 'twin.macro';

export const Wrapper = styled.div`
  ${tw`float-right w-tableOfContentWidth pl-8`};
`;

export const FixedWrapper = styled.div`
  ${tw`fixed`};
  ${tw`pl-6 pr-[24px] w-[inherit]`};
  ${tw`border-l-[1px] border-l-borderColor`};
`;

export const Title = styled.h3`
  ${tw`mb-5 font-medium text-sm`}
`;

export const AnchorWrapper = styled.div`
  ${tw`flex flex-col`};
`;

export const StyledLink = styled(Link)`
  ${tw`text-xs mb-2`}
`;

export const StyledTextLink = styled.span(({ isActive }: { isActive: boolean }) => [
  isActive && tw`text-link font-medium`,
  tw`inline-block`,
  tw`hover:text-link-hover hover:font-medium`,
]);
